/* Imports */
import React from "react"
import { Font, Flexbox, Tooltip, Variables } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const TooltipPage = () => {
    const items = [
        {
            title: "Dotted",
            content: (
                <Flexbox padding={`${Variables.Spacers.XL} 0 0`}>
                    <Font.P>
                        Text with{" "}
                        <Tooltip
                            tooltip="Tooltip"
                            textStyle="dotted"
                            color="primary"
                        >
                            tooltip
                        </Tooltip>{" "}
                        text
                    </Font.P>
                </Flexbox>
            ),
            code: '<Font.P>\n    Text with{" "}\n    <Tooltip tooltip="Tooltip" textStyle="dotted" color="primary">\n        tooltip\n    </Tooltip>{" "}\n    text\n</Font.P>',
        },
        {
            title: "Underline",
            content: (
                <Flexbox padding={`${Variables.Spacers.XL} 0 0`}>
                    <Font.P>
                        Text with{" "}
                        <Tooltip
                            tooltip="Tooltip"
                            textStyle="underline"
                            color="secondary"
                        >
                            tooltip
                        </Tooltip>{" "}
                        text
                    </Font.P>
                </Flexbox>
            ),
            code: '<Font.P>\n    Text with{" "}\n    <Tooltip tooltip="Tooltip" textStyle="underline" color="secondary">\n        tooltip\n    </Tooltip>{" "}\n    text\n</Font.P>',
        },
        {
            title: "Bold",
            content: (
                <Flexbox padding={`${Variables.Spacers.XL} 0 0`}>
                    <Font.P>
                        Text with{" "}
                        <Tooltip tooltip="Tooltip" textStyle="bold">
                            tooltip
                        </Tooltip>{" "}
                        text
                    </Font.P>
                </Flexbox>
            ),
            code: '<Font.P>\n    Text with{" "}\n    <Tooltip tooltip="Tooltip" textStyle="bold">\n        tooltip\n    </Tooltip>{" "}\n    text\n</Font.P>',
        },
    ]

    const propsItems = [
        {
            name: "tooltip",
            type: "String",
            required: "Yes",
        },
        {
            name: "textStyle",
            type: "String",
            example: "bold",
            possible: '"dotted" | "underline" | "bold"',
            default: "dotted",
        },
        {
            name: "color",
            type: "String",
            example: "secondary-400",
            possible: commonProps.allColors,
            default: "currentColor",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default TooltipPage
